"use strict";
export default {
  url: function(page, raw = false) {
    const fullUrl = raw ? page.rawFullUrl : page.fullUrl;
    return this.addRotation(page.inProcessRotation, fullUrl);
  },
  thumbnail: function(page) {
    return this.addRotation(page.inProcessRotation, page.thumbnail);
  },
  addRotation: function(degrees, url) {
    if (degrees && degrees > 0) {
      url = url + "&or=" + degrees;
    }
    return url;
  }
};
